import React from "react";
import { MdArrowForwardIos } from "react-icons/md";
import { SiCircle } from "react-icons/si";
import { missionVisionMenu } from "../../constants/data";
import { colors } from "../../constants/theme";
const MissionVision = () => {
  return (
    <>
      <div className="md:flex items-center py-10 md:py-20">
        {/* Description */}
        <div className="my-2 py-5 w-full md:px-28 px-10">
          <SiCircle className=" text-gray-700" size={40} />
          <h1
            style={{}}
            className=" font-light md:text-4xl text-2xl text-pink-600 uppercase"
          >
            Who are we?
          </h1>
          <p className="font-normal text-md text-gray-700 text-left mt-8">
            we are RemotewebNET Dynamics,a leading provider of IT consulting,
            Technical support, and solutions for medium and large-sized
            businesses. It’s a privately owned company founded in the year 2012
            with its headquarters located in Abuja Nigeria. Our experienced
            technicians and engineers work with clients to understand their
            unique technology needs and provide solutions
          </p>
        </div>
        {/* Conatiner */}
        <div
          style={{ background: colors.blueColor }}
          className="md:mr-28 text-white md:px-16 px-10 py-4 w-full "
        >
          {missionVisionMenu.map((item, index) => (
            <div
              key={index}
              className={`font-light flex items-center justify-between py-4 text-sm cursor-pointer ${
                index === missionVisionMenu.length - 1
                  ? ""
                  : "border-b border-b-white"
              }`}
            >
              <p>{item.name}</p>
              {/* <MdArrowForwardIos size={20} /> */}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
// AiOutlineRadarChart
export default MissionVision;
